import React, { useState } from 'react'
import MathJaxView from '@/views/MathJaxView'
import TranslationList from '@/resources/TranslationList.json'
import ConstantList from '@/resources/ConstantsList.json'

type Props = {
  selectItem:
    | 'frizz'
    | 'frizzle'
    | 'kafrizz'
    | 'kafrizzle'
    | 'crack'
    | 'crackle'
    | 'kacrack'
    | 'kacrackle'
    | 'woosh'
    | 'swoosh'
    | 'kaswoosh'
    | 'kaswooshle'
    | 'bang'
    | 'boom'
    | 'kaboom'
    | 'kaboomle'
    | 'zam'
    | 'zammle'
    | 'kazam'
    | 'kazammle'
    | 'heal'
    | 'midheal'
    | 'moreheal'
    | 'multiheal'
    | 'gigaslash'
    | 'gigagash'
    | 'lightning-storm'
    | 'hand-of-god'
    | 'whopper-chop'
    | 'boulder-toss'
    | 'solar-flair'
}

const FormulaView = ({ selectItem }: Props) => {
  const constant = ConstantList[selectItem] as {
    dependencies: string[]
    x1: number
    x2: number
    y1: number
    y2: number
    epsilon: number
  }
  const attributes = TranslationList.attributes as Record<string, string>
  const dependencies = constant.dependencies
  const x1 = constant.x1
  const x2 = constant.x2
  const y1 = constant.y1
  const y2 = constant.y2
  const epsilon = constant.epsilon

  const [x, setX] = useState<number>(-1)
  const changeX = (e: React.ChangeEvent<HTMLInputElement>) => setX(parseInt(e.currentTarget.value))

  const [resultView, setResultView] = useState(<></>)

  const onButtonClick = () => {
    if (x < 0) {
      setResultView(<></>)
      return
    }
    let y
    if (x < x1) {
      y = y1
    } else if (x1 <= x && x <= x2) {
      y = ~~(((x - x1) * (y2 - y1)) / (x2 - x1)) + y1
    } else {
      y = y2
    }
    setResultView(
      <>
        計算結果：
        <MathJaxView text={`\\(y=${y} \\pm ${epsilon}\\)`} />
        <br />
        ダメージ量（回復量）の範囲：
        <br />
        <div style={{ fontWeight: 'bold' }}>{`${y - epsilon}～${y + epsilon}`}</div>
      </>
    )
  }

  return (
    <>
      「{TranslationList['spells-and-abilities'][selectItem]}」の定数値：
      <br />
      <MathJaxView text={`\\((x_1,x_2,y_1,y_2,\\epsilon)=(${x1},${x2},${y1},${y2},${epsilon})\\)`} />
      <br />
      <br />「{TranslationList['spells-and-abilities'][selectItem]}」の計算式：
      <br />
      <MathJaxView
        text={`\\( 
            y=
            \\begin{cases}
            ${y1} \\pm ${epsilon} & ( 0 \\leq x \\lt ${x1} ) \\\\
            (x-${x1}) \\times \\displaystyle\\frac{${y2 - y1}}{${
          x2 - x1
        }} + ${y1} \\pm ${epsilon} & ( ${x1} \\leq x \\leq ${x2} ) \\\\
            ${
              ~~(x2 / dependencies.length) === 999
                ? ``
                : `${y2} \\pm ${epsilon} & ( ${x2} \\lt x \\leq ${999 * dependencies.length})`
            }
            \\end{cases}
          \\)`}
      />
      <br />
      <MathJaxView
        text={`\\(x\\)の値（${dependencies.map((s) => attributes[s]).join('＋')}）を半角数字で入力：`}
      />
      <table>
        <tbody>
          <tr>
            <td>
              <input
                type='number'
                style={{ width: '156px', height: '20px' }}
                onChange={changeX}
                max={999 * dependencies.length}
                min='0'
              />
            </td>
            <td>
              <button onClick={onButtonClick}>計算</button>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      {resultView}
    </>
  )
}

export default FormulaView
